<template lang='pug'>
  #app
    bf-modal#welcome-modal( :show='!!$route.params.modals' )
      .container
        h3.heading {{ $t("Welcome to BlueFaucet!")}}
        p {{ $t("You have completed the registration process. Closing this dialogue will lead you to your personal homepage, where you can browse for services and products near you. You may now use BlueFaucet to make a reservation with other sellers for their services or products.") }}
        bf-divider.borderless.card
        .bf-merchant( @click='$router.push({ name: "welcome"})' )
          bf-button.bright.wide
            template(v-slot:text) {{ $t("Close and go to personal homepage") }}
        bf-divider.borderless.card
        p {{ $t("If you would like to offer your services, or plan to sell products, please continue and fill out the form for registering your business to enable selling features. After registering your business, your homepage will now display your business dashboard.")}}
        bf-divider.borderless.card
        p {{ $t("Click on the Home icon in the corner or select 'User Home' from the dropdown menu to view your personal home page.")}}
        bf-divider.borderless.card
        p {{ $t("You can always opt to complete this form later.")}}
        bf-divider.borderless.card
        .bf-merchant( @click='$router.push({ name: "upgrade"})' )
          bf-button.bright.wide
            template(v-slot:text) {{ $t("Register my business and enable Selling") }}
        bf-divider.borderless.card
        p {{ $t("If you are using Android or iOS devices, you can install BlueFaucet by clicking the button below:")}}
        a(href="https://play.google.com/store/apps/details?id=com.bluefaucet.app.phoenix&amp;pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1" target="_blank")
          img(width="200" src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png")
        a(href="https://itunes.apple.com/us/app/bluefaucet/id1534392907?mt=8" target="_blank")
          img(width="180" src="https://www.bluefaucet.com/wp-content/uploads/2020/10/iosapp-t.png")
        button.close( @click='$router.push({ name: "welcome" })' )
          close-icon

    bf-nav#main-nav(
      v-if='!authenticating'
      ref='nav'
      :user='user'
      :account='account'
      :biz='biz'
      :notifications='notifications'
      @signed-out=''
    )
      template(v-slot:header)
        slot(name='header')

    router-view.view(
      v-show='!( $route.meta.requiresAuth && !account.id && $route.meta.requiresMerchant )'
      :user='user'
      :account='account'
      :biz='biz'
      :key='$route.fullPath + key'
      :srvs='srvs'
      :prds='prds'
      :cats='cats'
      :csts='csts'
      :modals.sync='modals'
      :notifications='notifications'
      @close-modal='modals[$event] = false'
      @click.native='close'
      @sign-up='accountify'
      @upgraded='upgraded'
      @password-linked='linked'
    )
</template>

<script>
  import { msgr } from '@/main'
  import { Account } from '@/mixins/account'
  import { Authenticable } from '@/mixins/authenticable'
  import { db, firebase } from '@/main'
  const pinyin = require("pinyin")

  export default {
    name: 'app',

    mixins: [ Account, Authenticable ],

    data() {
      return {
        key: 0,
        modals: { srvs: false, csts: false },
      }
    },

    computed: {
      authenticating() {
        return [ 'forgot-password', "sign-in", "sign-up",  "sign-up-ref", "sign-up-phone", "sign-up-link", "sign-up-friend" ].includes( this.$route.name )
      }
    },

    methods: {
      linked( user ) {
        this.user = user
        console.log('email linked', user)
      },

      upgraded( slug ) {
        console.log('upgraded event handler called', slug)
      },

      close() {
        if ( !this.authenticating ) this.$refs.nav.open.left = false
      },

      welcome() {
        this.$router.push({ name: 'welcome' })
      },

      handlers() {
        msgr.onMessage( payload => console.log('Message Received:  ', payload) )
      },

      tokenize() {
        msgr.getToken().then( token => {
          if (token) {
            console.log('Token retreived!')
            this.account.tokens = this.account.tokens || {}
            if ( this.account.tokens && this.account.tokens.fcm != token ) {
              console.log('Updating token...')
              db.collection('accounts').doc(this.account.id).update({
                tokens: { fcm: token }
              }).then( () => console.log('Token saved/stored') )
            }
          }
          else {
            console.log('Token NOT retieved!')
            console.log('No Instance ID token available. Request permission to generate one.')
          }
        }).catch( err => {
          console.log('An error occurred while retrieving token. ', err)
        })
      },

      refresh() {
        msgr.onTokenRefresh( () => {
          console.log('Token refresh triggered')
          msgr.getToken().then( refreshedToken => {
            console.log('New token retrieved.')
            db.collection('accounts').doc(this.account.id).update({
              tokens: { fcm: token }
            }).then( () => console.log( 'Token saved/stored' ) )
          }).catch( err => console.log( 'Unable to retrieve refreshed token ', err ) )
        })
      }
    }
  }
</script>

<style lang="stylus">
  @import 'https://cdnjs.cloudflare.com/ajax/libs/meyer-reset/2.0/reset.min.css'
  @import url('https://fonts.googleapis.com/css?family=Open+Sans|Quicksand|Ubuntu|Lato|Inconsolata|Special+Elite')

  :root
    --shadow-panel 0 0 16px 0 rgba( 40 80 120 .75 )
    --shadow-box 0 0 12px 0 rgba( 0 0 0 .2 )
    --shadow-box-shallow 0 0 8px 0 rgba( 0 0 0 .1 )
    --shadow-card 0 0 8px 0 rgba( 125 125 125 .1 )
    --shadow-card-hover 0 0 12px 0 rgba( 175 150 125 .64 )
    --shadow-border   0 1px 1px 0 rgba( 255 255 255 1)
    --shadow-text  0 0 1px 2px rgba( 255 255 255 1 )
    --text-shadow-rev 0 -1px 2px rgba( 0,0,0,.2 )
    --shadow-text-rev 0 -1px 2px rgba( 0,0,0,.2 )
    --clr-active rgb( 255 225 255 )
    --clr-light  rgb( 248,248,248 )
    --clr-dark   rgb( 64 64 64 )
    --clr-blue   rgb( 32 80 152 )
    --clr-blue-light rgb( 0 192 244 )
    --clr-notice white
    --clr-orange rgb( 248 144 64 )
    --clr-orange-light rgb( 255 225 205 )
    --clr-text rgb( 80 80 80 )
    --clr-heading var(--clr-text)
    --clr-button rgb( 255 250 240 )
    --clr-button-hover rgb( 255 255 255 )
    --clr-nav var(--clr-button)
    --clr-border rgb( 255 255 255 )
    --clr-primary rgb( 200, 100, 150 )
    --clr-accent rgb( 200 100 200 )

    --width-nav 300px
    --height-top-nav 106px
    --height-merchant-nav 88px

    --bg-body white

    --bg-inactive rgba( 250 250 250 .7 )

    --bg-nav rgb( 31 69 144 )

    --bg-nav-hover linear-gradient(
      -135deg,
      rgb( 48 64 144 ),
      rgb( 32 88 128 )
    )

    --bg-button var(--bg-nav-hover)

    --bg-overlay linear-gradient(
      45deg,
      rgba( 225 200 255 .96 ),
      rgba( 255 225 255 .96 ),
      rgba( 255 225 200 .96 )
    )


    --bg-button-hover linear-gradient(
      -45deg,
      rgba( 235 195 125 .88 ),
      rgba( 245 150 75 .88 )
    )

    --bg-panel linear-gradient(
      -135deg,
      rgba( 40 100 160 .98),
      rgba( 40 75 175 .96)
    )

    --bg-card linear-gradient(
      135deg,
      rgb( 255 235 235 ),
      rgb( 245 245 245 ),
      rgb( 250 240 255 )
    )

    --bg-btn linear-gradient(
      135deg,
      rgba( 255 254 252 .9 ),
      rgba( 255 252 248 .9 )
    )

    --bg-notice linear-gradient(
      90deg,
      rgb( 200 92 96 ),
      rgb( 225 135 80 )
    )

  ::placeholder, optgroup.label
    color rgb( 88 108 128 ) !important
    font-weight normal

  ::-webkit-scrollbar
    width 8px

  ::-webkit-scrollbar-thumb
    background var(--clr-light)
    border-radius 4px

  ::-webkit-scrollbar-track
    background none

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus
    transition background-color 9999s ease-in-out 9999s
    -webkit-box-shadow: none //0 0 0 100px #fff inset;
    -moz-box-shadow: none //0 0 0 100px #fff inset;
    background 0
    box-shadow: 0 0 0 64px rgb(255 252 248) inset

  body, #app
    font-family Quicksand //Lato //"Open Sans"
    color var(--clr-text)
    min-height 100vh
    background var(--bg-body)
    background-attachment fixed
    line-height 1.25
    box-sizing border-box
    font-size .88em
    overflow-x hidden
    @media(min-width: 360px)
      font-size .88em
    @media(min-width: 800px)
      font-size .91em
    @media(min-width: 1080px)
      font-size .94em

  h1, h2, h3, h4, h5, h6
    letter-spacing .25px
    line-height inherit
    color var(--clr-heading)
    font-family inherit
    font-weight bold
    color inherit

  h1
    font-size 2.4em
  h2
    font-size 2.0em
  h3
    font-size 1.6em
  h4
    font-size 1.4em
  h5
    font-size 1.2em
  h6
    font-size 1.0em

  a
    cursor pointer
    color inherit
    text-decoration inherit
    transition transform 320ms

  input, select, textarea, button
    background 0
    border 0
    color inherit
    font-family inherit
    text-align inherit
    font-size inherit
    padding 4px 0
    text-shadow inherit
    font-weight bold
    &:focus, &:active
      outline 0

  textarea
    height 88px
    width 100%

  select
    margin-left -4px
    display block
    width 100%


  #welcome-modal
    font-size 1.2em
    .close
      position absolute
      top 10px
      right 10px
      background white
      border-radius 50%
      width 36px
      height 36px
      border 1.5px solid var(--clr-orange)
      font-size .5em
      display flex
      align-items center
      justify-content center
      padding-top 6px
      color rgb( 160 160 160 )

  .view
    min-height calc( 100vh - 52.2px )
  .v-leave
    // transform scale(1)

  .v-leave-to
    transform scale(.88) translateY(390px)
    transition all 360ms
    height 0
    *
      display none

  .v-enter
    opacity 0
    transform translateX(100vw)

  .v-enter-to
    opacity 1
    transition all 360ms
    transform translateX(0)

  .router-link-active
    // color var(--clr-text)

  .actionable, select, button
    cursor pointer

  .container
    position relative

  .centered-text
    text-align center

  .desc
    margin-top 8px
    font-size .92em
    white-space pre-line

  .icon img
    display block
    width 100%
    height 100%
    object-fit contain

  .input-container
    input
      width 100%

  .system-message
    font-family Ubuntu

  .ellipsis
    white-space nowrap
    overflow hidden
    text-overflow ellipsis

  .notable
    color red

  .enlarge
    font-size 1.2em

  .auth-link
    text-align center
    font-size 1.1em
    a
      margin-left 8px
      color var(--clr-blue)
      font-weight bold

  .bright
    color var(--clr-blue-light)
</style>
